export default __webpack_public_path__ + "static/media/calender.a3718fab.svg";